module.exports = __webpack_public_path__ + "fonts/Gilroy-UltraLight.1b3e628e.eot";